import { render, staticRenderFns } from "./SectionBlockTypeSetup.vue?vue&type=template&id=d30b15c6&"
import script from "./SectionBlockTypeSetup.vue?vue&type=script&lang=js&"
export * from "./SectionBlockTypeSetup.vue?vue&type=script&lang=js&"
import style0 from "./SectionBlockTypeSetup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports